var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClipboardConfigureFieldsGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M147.5 33.79H99.5701V73.33H147.5V33.79Z",
    fill: "#CDD9E2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M147.5 33.79H99.5701V73.33H147.5V33.79Z",
    stroke: "#CDD9E2",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M85.21 21.52H3.67C3.02383 21.52 2.5 22.0438 2.5 22.69V121C2.5 121.646 3.02383 122.17 3.67 122.17H85.21C85.8562 122.17 86.38 121.646 86.38 121V22.69C86.38 22.0438 85.8562 21.52 85.21 21.52Z",
    fill: "#B4C5D0",
    stroke: "#B4C5D0",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M68.4 18.18V32.74H20.47V18.18H34.85C34.8085 16.8953 35.0257 15.6153 35.4887 14.4161C35.9517 13.2169 36.6511 12.1231 37.5452 11.1996C38.4394 10.2761 39.51 9.5418 40.6936 9.04031C41.8772 8.53882 43.1495 8.2804 44.435 8.2804C45.7204 8.2804 46.9927 8.53882 48.1763 9.04031C49.3599 9.5418 50.4306 10.2761 51.3247 11.1996C52.2189 12.1231 52.9182 13.2169 53.3813 14.4161C53.8443 15.6153 54.0615 16.8953 54.02 18.18H68.4Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M68.4 44.4601H20.47V80.4101H68.4V44.4601Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M80.3799 48.88V28.35C80.3885 28.0707 80.2896 27.7988 80.1035 27.5903C79.9174 27.3819 79.6584 27.2529 79.3799 27.23H72.3799",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0599 27.23H9.54993C9.40677 27.2339 9.26578 27.2659 9.13502 27.3243C9.00426 27.3827 8.88628 27.4663 8.78784 27.5703C8.6894 27.6743 8.61242 27.7967 8.5613 27.9305C8.51019 28.0643 8.48593 28.2068 8.48993 28.35V114.79C8.48594 114.933 8.51027 115.075 8.5615 115.208C8.61274 115.341 8.68987 115.463 8.78844 115.566C8.88701 115.669 9.00505 115.752 9.13576 115.809C9.26646 115.867 9.40723 115.897 9.54993 115.9L70.7999 116.46L80.3799 106.87V60.36",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M70.8 116.46V106.87H80.39",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20.47 97.1801H68.4",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M20.47 91.1901H68.4",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M20.47 103.17H56.42",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M123.99 44.65H142.72",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M123.99 50H142.72",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M123.99 59.36H142.72",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M123.99 64.7101H133.35",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M115.96 48.66V51.34H106.59V41.97H113.28",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M107.97 46L111.28 49.31L118.59 42",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M115.97 58.02H106.6V67.39H115.97V58.02Z",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M136.45 96.24H139.11V98.91",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M139.11 103.64V139.13",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "4.73 4.73"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M139.11 141.5V144.17H136.45",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M131.56 144.17H104.68",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "4.89 4.89"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M102.24 144.17H99.5701V141.5",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5701 136.77V101.27",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "4.73 4.73"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5701 98.91V96.24H102.24",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M107.12 96.24H134",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "4.89 4.89"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M122.04 106.73L119.34 108.75L116.65 106.73",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M116.65 121.55L119.34 119.53L122.04 121.55",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M114.27 108.1L114.67 111.44L111.58 112.77",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M124.41 120.18L124.01 116.83L127.11 115.51",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M119.34 123.23V105.04",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M127.22 118.69L111.47 109.59",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M127.22 109.59L111.47 118.69",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M111.58 115.51L114.67 116.83L114.27 120.18",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M127.11 112.77L124.01 111.44L124.41 108.1",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M107.22 129.76H131.47",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M107.22 134.55H119.34",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M44.44 22.37C46.7541 22.37 48.63 20.4941 48.63 18.18C48.63 15.8659 46.7541 13.99 44.44 13.99C42.1259 13.99 40.25 15.8659 40.25 18.18C40.25 20.4941 42.1259 22.37 44.44 22.37Z",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M62.41 27.23H26.46",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M20.47 22.8V18.18H34.85C34.8085 16.8953 35.0257 15.6153 35.4887 14.4161C35.9517 13.2169 36.6511 12.1231 37.5452 11.1996C38.4394 10.2761 39.51 9.5418 40.6936 9.04031C41.8772 8.53882 43.1495 8.2804 44.435 8.2804C45.7204 8.2804 46.9927 8.53882 48.1763 9.04031C49.3599 9.5418 50.4306 10.2761 51.3247 11.1996C52.2189 12.1231 52.9182 13.2169 53.3813 14.4161C53.8443 15.6153 54.0615 16.8953 54.02 18.18H68.4V22.8",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M93 51.9101C77.28 45.9101 75.78 64.3501 60.3 65.6101",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4399 61.78L54.8899 65.39L61.2899 69.26L61.4399 61.78Z",
    fill: "#1F323D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboardConfigureFieldsGrey);
export default __webpack_public_path__ + "static/media/clipboard_configure_fields_grey.b74c4906d97b58f0e7864f9afb354709.svg";
export { ForwardRef as ReactComponent };